(function() {

    let scanner = null;
    let connected = false;
    let configuration = null;
    let camera = null;

    let BarcodeScanner = {

        initialize: async function(args) {
            configuration = args;

            /* Disconnect the previous scanner */

            if (scanner && scanner.disconnect) {
                scanner.disconnect();
            }

            /* Initialize the new scanner */

            if (configuration.connection == 'hid') {
                let WebHIDBarcodeScanner = await requireAsync([ 'core/lib/point-of-sale/webhid-barcode-scanner.umd' ])

                scanner = new WebHIDBarcodeScanner();

                scanner.addEventListener('connected', e => {
                    connected = true;
                });

                scanner.addEventListener('disconnected', e => {
                    connected = false;
                });

                scanner.addEventListener('barcode', e => {
                    Runtime.Loader.Platform.command('barcode', e);
                });

                scanner.reconnect(configuration.device);
            }
        },

        start: async function () {
            if (scanner && scanner.disconnect) {
                scanner.disconnect();
            }

            if (configuration.connection == 'webcam') {
                let WebcamBarcodeScanner = await requireAsync([ 'core/lib/point-of-sale/webcam-barcode-scanner.umd' ])

                scanner = new WebcamBarcodeScanner({
                    workerPath: '../../../core/lib/point-of-sale/webcam-barcode-scanner.worker.js',
                    binaryPath: 'https://cdn.jsdelivr.net/gh/NielsLeenheer/WebcamBarcodeScanner@main/dist/webcam-barcode-scanner.wasm',

                    allowedSymbologies: [ 'ean13', 'ean8', 'upca', 'upce', 'code128', 'qr-code' ],
                    beepOnScan: true,
                    preview: {
                        zoom: 2,
                        zIndex: 99999,
                        size: 160,
                        draggable: true,
                        position: 'bottom-right',
                        padding: {
                            top: 60, 
                            left: 20,
                            right: 30,
                            bottom: 20
                        },
                        menu: {
                            enabled: false
                        }
                    }
                });

                scanner.addEventListener('connected', device => {
                    Runtime.Storage.write('barcodeScanner', { connection: configuration.connection, device });

                    camera = device.deviceId;
                    connected = true;
                });

                scanner.addEventListener('changed', device => {
                    Runtime.Storage.write('barcodeScanner', { connection: configuration.connection, device });

                    camera = device.deviceId;
                });

                scanner.addEventListener('disconnected', e => {
                    camera = null;
                    connected = false;
                });

                scanner.addEventListener('barcode', e => {
                    Runtime.Loader.Platform.command('barcode', e);
                });


                /* Try to reconnect to the last device */

                let last = await Runtime.Storage.read({ name: 'barcodeScanner' });

                if (last && last.device) {
                    let result = await scanner.reconnect(last.device);

                    if (result) {
                        return;
                    }
                }

                /* Connect to a new device */

                await scanner.connect();
            }
        },

        stop: function () {
            if (scanner && scanner.disconnect) {
                scanner.disconnect();
            }
        },

        change: async function (id) {
            if (scanner && scanner.change) {
                let result = await scanner.change(id);

                if (!result) {
                    new Window.Alert({
                        message:        'Kon de camera niet wisselen',
                        explaination:   'Tijdens het starten van de gekozen camera is er een fout opgetreden. Probeer opnieuw, of kies een andere camera.',
                        button:		    { title: 'OK', color: 'green' },
                    });
                }
            }
        },

        getCameras: function() {
            return scanner.devices.map(device => ({ 
                ...device, 
                label: device.label.replace(/\s*\([a-z0-9]{4,4}:[a-z0-9]{4,4}\)$/i, ''), 
                selected: device.deviceId == camera 
            }));
        },

        getCapabilities: async function() {
            let capabilities = {
                keyboard:   true,
                webcam:     true,
            };
    

            if (navigator.hid) {
                capabilities.hid = {
                    manual: true,
                    devices: []
                };
            }
    
            return capabilities;
        },

        get connected() {
            return connected;
        }
    };

    DeviceManager.Internal.BarcodeScanner = BarcodeScanner;
})();

